//Deliverect product tags
export const VEGAN_TAG = '4';
export const VEGETARIAN_TAG = '5';
export const GLUTEN_FREE_TAG = '1101';

export const ALLERGENS_MAP = {
  CELERY: '100',
  GLUTEN: '101',
  CRUSTACEANS: '102',
  FISH: '103',
  EGGS: '104',
  LUPIN: '105',
  MILK: '106',
  MOLLUSCS: '107',
  MUSTARD: '108',
  NUTS: '109',
  PEANUTS: '110',
  SESAME: '111',
  SOYA: '112',
  SULPHITES: '113',
  ALMONDS: '114',
  BARLEY: '115',
  BRAZIL_NUTS: '116',
  CASHEW: '117',
  HAZELNUTS: '118',
  KAMUT: '119',
  MACADAMIA: '120',
  OATS: '121',
  PECAN: '122',
  PISTACHIOS: '123',
  RYE: '124',
  SPELT: '125',
  WALNUTS: '126',
  WHEAT: '127',
  SUGARED_DRINK: '128',
  DAIRY: '129',
  LENTILS: '130',
  QUEENSLAND_NUTS: '131',
  SHELLFISH: '132',
  TREENUTS: '133',
  SOURCES_OF_GLUTEN: '134',
} as const;

export const ALLERGENS = Object.entries(ALLERGENS_MAP).map(([key, value]) => ({ key, value }));
